import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AppLocalStorage } from './local-storage.util';
import { v4 as uuidv4 } from 'uuid';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserTrackingService implements OnDestroy {
  baseUrl = environment.api.core.base;
  path = environment.api.intranet.telemetry.endpoint;
  eventPath = this.baseUrl + this.path;
  trackEvent: boolean;
  private token: string;
  private sessionId: string;
  private readonly SESSION_TIMEOUT_MS = 30 * 60 * 1000; // 30 mins

  constructor(private http: HttpClient) {
    this.trackEvent = environment.eventTrack;
    this.ensureSessionId();
  }

  ngOnDestroy(): void {
   
  }

  

  private ensureSessionId(): void {
    const storedSessionId = sessionStorage.getItem('mi_tracking_session_id');
    const lastApiCallTimestamp = sessionStorage.getItem('mi_last_api_call_timestamp');

    const currentTime = new Date().getTime();
    let isSessionExpired = false;

    if (lastApiCallTimestamp) {
      const lastCallTime = parseInt(lastApiCallTimestamp, 10);
      if (currentTime - lastCallTime > this.SESSION_TIMEOUT_MS) {
        isSessionExpired = true;
      }
    }

    if (storedSessionId && !isSessionExpired) {
      this.sessionId = storedSessionId;
    } else {
      this.sessionId = uuidv4();
      sessionStorage.setItem('mi_tracking_session_id', this.sessionId);
    }
  }

  private updateLastApiCallTimestamp(): void {
    sessionStorage.setItem('mi_last_api_call_timestamp', new Date().getTime().toString());
  }

  private preparePayload(eventName: string, properties: any, feature: string) {
    return [{
      eventName,
      properties: JSON.stringify(properties),
      sessionId: this.sessionId,
      eventTime: new Date().toISOString(),
      source: 'MI',
      feature
    }];
  }

  track(eventName: string, properties: any, feature: string) {
    if (!this.trackEvent) return;

    const sessionData: any = AppLocalStorage.get('SESSION', 'SESSION') || {};
    this.token = sessionData?.token || '';

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    if (this.token) {
      headers = headers.set('Authorization', `Bearer ${this.token}`);
    }

    const payload = this.preparePayload(eventName, properties, feature);

    this.http.post(this.eventPath, payload, { headers, observe: 'response' }).pipe(
      catchError(err => {
        return EMPTY;
      })
    ).subscribe({
      next: () => this.updateLastApiCallTimestamp()
    });
  }
}
